/* 
   Révision 27/08/2026
   Les valeurs de filtres sont lues dynamiquement sur /collections/all au
   premier besoin, puis mises en cache pour la session. Un renommage futur
   des libellés côté Shopify ne cassera donc plus la recherche.
 */

(function (window, document) {
  'use strict';

  /* 1. Table de correspondance pointure / tour de mollet (en cm) */
  var TAILLES_MOLLET = {
    36: { 'XS': [27.9, 30.9], 'S': [30.9, 33.9], 'XL': [36.9, 39.9], '2XL': [39.9, 42.9], '3XL': [42.9, 45.9], '4XL': [45.9, 48.9], '5XL': [48.9, 51.9], '6XL': [51.9, 54.9] },
    37: { 'XS': [29.3, 32.3], 'S': [32.3, 35.3], 'XL': [38.3, 41.3], '2XL': [41.3, 44.3], '3XL': [44.3, 47.3], '4XL': [47.3, 50.3], '5XL': [50.3, 53.3], '6XL': [53.3, 56.3] },
    38: { 'XS': [29.3, 32.3], 'S': [32.3, 35.3], 'XL': [38.3, 41.3], '2XL': [41.3, 44.3], '3XL': [44.3, 47.3], '4XL': [47.3, 50.3], '5XL': [50.3, 53.3], '6XL': [53.3, 56.3] },
    39: { 'XS': [30.7, 33.7], 'S': [33.7, 36.7], 'XL': [39.7, 42.7], '2XL': [42.7, 45.7], '3XL': [45.7, 48.7], '4XL': [48.7, 51.7], '5XL': [51.7, 54.7], '6XL': [54.7, 57.7] },
    40: { 'XS': [30.7, 33.7], 'S': [33.7, 36.7], 'XL': [39.7, 42.7], '2XL': [42.7, 45.7], '3XL': [45.7, 48.7], '4XL': [48.7, 51.7], '5XL': [51.7, 54.7], '6XL': [54.7, 57.7] },
    41: { 'XS': [32.1, 35.1], 'S': [35.1, 38.1], 'XL': [41.1, 44.1], '2XL': [44.1, 47.1], '3XL': [47.1, 50.1], '4XL': [50.1, 53.1], '5XL': [53.1, 56.1], '6XL': [56.1, 59.1] },
    42: { 'XL': [41.1, 44.1], '2XL': [44.1, 47.1], '3XL': [47.1, 50.1], '4XL': [50.1, 53.1], '5XL': [53.1, 56.1], '6XL': [56.1, 59.1] },
    43: { 'XL': [42.5, 45.5], '2XL': [45.5, 48.5], '3XL': [48.5, 51.5], '4XL': [51.5, 54.5], '5XL': [54.5, 57.5], '6XL': [57.5, 60.5] },
    44: { 'XL': [42.5, 45.5], '2XL': [45.5, 48.5], '3XL': [48.5, 51.5], '4XL': [51.5, 54.5], '5XL': [54.5, 57.5], '6XL': [57.5, 60.5] },
    45: { 'XL': [43.9, 46.9], '2XL': [46.9, 49.9], '3XL': [49.9, 52.9], '4XL': [52.9, 55.9], '5XL': [55.9, 58.9], '6XL': [58.9, 61.9] }
  };

  /* Tailles VARIO à inclure en plus de la taille calculée. */
  var VARIO_PAR_TAILLE = {
    'XL':  ['VARIO XL/2XL'],
    '2XL': ['VARIO XL/2XL', 'VARIO 2XL/3XL'],
    '3XL': ['VARIO 2XL/3XL', 'VARIO 3XL/4XL'],
    '4XL': ['VARIO 3XL/4XL', 'VARIO 4XL/5XL'],
    '5XL': ['VARIO 4XL/5XL', 'VARIO 5XL/6XL'],
    '6XL': ['VARIO 5XL/6XL']
  };

  /* Valeurs de repli . */
  var POINTURES_REPLI = {
    36: '36 (EU) - 3.5 (UK)',
    37: '37 (EU) - 4 (UK)',
    38: '38 (EU) - 5 (UK)',
    39: '39 (EU) - 5.5 (UK)',
    40: '40 (EU) - 6.5 (UK)',
    41: '41 (EU) - 7.5 (UK)',
    42: '42 (EU) - 8 (UK)',
    43: '43 (EU) - 9 (UK)',
    44: '44 (EU) - 9.5 (UK)',
    45: '45 (EU) - 10 (UK)'
  };

  var CLE_FILTRE_POINTURE = 'filter.v.option.taille';
  var CLE_FILTRE_MOLLET = 'filter.p.m.custom.tailledemollet';
  var CLE_CACHE = 'gabylou:filtres:v1';
  var DUREE_CACHE = 12 * 60 * 60 * 1000; // 12 h

  /* 2. Utilitaires de calcul */

  /* Racine du site en tenant compte de la langue (/, /nl/, /en/). */
  function racine() {
    var segment = window.location.pathname.split('/')[1];
    return (segment === 'nl' || segment === 'en') ? '/' + segment + '/' : '/';
  }

  /* Retourne la taille de mollet (XS, S, XL, 2XL...) ou '' si aucune
     plage ne correspond. */
  function tailleMollet(pointure, mollet) {
    var plages = TAILLES_MOLLET[pointure];
    var valeur = parseFloat(mollet);
    if (!plages || isNaN(valeur)) return '';
    for (var cle in plages) {
      if (!Object.prototype.hasOwnProperty.call(plages, cle)) continue;
      if (valeur >= plages[cle][0] && valeur <= plages[cle][1]) return cle;
    }
    return '';
  }

  /* Liste des valeurs de tour de mollet à proposer pour une pointure.
     Chaque entrée indique si elle est couverte par une plage réelle. */
  function optionsMollet(pointure) {
    var plages = TAILLES_MOLLET[pointure];
    if (!plages) return [];

    var min = Infinity;
    var max = -Infinity;
    for (var cle in plages) {
      if (!Object.prototype.hasOwnProperty.call(plages, cle)) continue;
      min = Math.min(min, plages[cle][0]);
      max = Math.max(max, plages[cle][1]);
    }
    min = Math.ceil(min * 2) / 2;

    var liste = [];
    for (var v = min; v <= max; v += 0.5) {
      var valeur = v.toFixed(1);
      liste.push({ valeur: valeur, couverte: tailleMollet(pointure, valeur) !== '' });
    }
    return liste;
  }

  /* Pointure logique (36 à 45) d'un <select>, que ses options portent
     encore la valeur brute ou déjà le libellé de filtre Shopify. */
  function pointureSelectionnee(select) {
    if (!select) return '';
    var option = select.options[select.selectedIndex];
    if (!option) return '';
    return option.getAttribute('data-pointure') || option.value || '';
  }

  /* -------------------------------------------------------------------
     3. Lecture des valeurs de filtres réellement exposées par Shopify
     ------------------------------------------------------------------- */

  function lireCache() {
    try {
      var brut = window.sessionStorage.getItem(CLE_CACHE);
      if (!brut) return null;
      var bloc = JSON.parse(brut);
      if (bloc && bloc.t && (Date.now() - bloc.t) < DUREE_CACHE) return bloc.d;
    } catch (e) { /* sessionStorage indisponible */ }
    return null;
  }

  function ecrireCache(donnees) {
    try {
      window.sessionStorage.setItem(CLE_CACHE, JSON.stringify({ t: Date.now(), d: donnees }));
    } catch (e) { /* quota ou navigation privée */ }
  }

  function extraireFiltres(doc) {
    var resultat = { pointures: {}, mollets: [] };
    var i;

    var champsPointure = doc.querySelectorAll('input[name="' + CLE_FILTRE_POINTURE + '"]');
    for (i = 0; i < champsPointure.length; i++) {
      var brut = champsPointure[i].value || '';
      var trouve = brut.match(/(\d{2})/);
      if (!trouve) continue;
      var pointure = parseInt(trouve[1], 10);
      if (pointure >= 30 && pointure <= 50) resultat.pointures[pointure] = brut;
    }

    var champsMollet = doc.querySelectorAll('input[name="' + CLE_FILTRE_MOLLET + '"]');
    for (i = 0; i < champsMollet.length; i++) {
      var valeur = champsMollet[i].value || '';
      if (valeur && resultat.mollets.indexOf(valeur) === -1) resultat.mollets.push(valeur);
    }

    return resultat;
  }

  var promesseFiltres = null;

  function chargerFiltres() {
    if (promesseFiltres) return promesseFiltres;

    var cache = lireCache();
    if (cache) {
      promesseFiltres = Promise.resolve(cache);
      return promesseFiltres;
    }

    promesseFiltres = window.fetch(racine() + 'collections/all', { credentials: 'same-origin' })
      .then(function (reponse) {
        if (!reponse.ok) throw new Error('HTTP ' + reponse.status);
        return reponse.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var donnees = extraireFiltres(doc);
        if (!Object.keys(donnees.pointures).length) throw new Error('aucune valeur de filtre trouvee');
        ecrireCache(donnees);
        return donnees;
      })
      .catch(function (erreur) {
        console.warn('[Gabylou] Valeurs de filtres illisibles, repli sur les valeurs par defaut.', erreur);
        return { pointures: POINTURES_REPLI, mollets: null };
      });

    return promesseFiltres;
  }

  /* -------------------------------------------------------------------
     4. Construction de l'URL de collection
     ---------------------------------------------------------------------
     URLSearchParams produit exactement l'encodage attendu par Shopify
     (espace en "+", slash en "%2F"), ce qui supprime l'encodage manuel
     de l'ancien code.
     ------------------------------------------------------------------- */
  function construireUrl(pointure, taille, filtres) {
    filtres = filtres || { pointures: POINTURES_REPLI, mollets: null };

    var params = new URLSearchParams();

    var libellePointure = (filtres.pointures && filtres.pointures[pointure]) || POINTURES_REPLI[pointure];
    if (libellePointure) params.append(CLE_FILTRE_POINTURE, libellePointure);

    var demandees = [taille].concat(VARIO_PAR_TAILLE[taille] || []);
    var retenues = demandees;

    // On écarte les valeurs VARIO qui n'existent pas dans le metafield,
    // sans jamais retirer la taille principale.
    if (filtres.mollets && filtres.mollets.length) {
      retenues = demandees.filter(function (valeur) {
        return valeur === taille || filtres.mollets.indexOf(valeur) !== -1;
      });
    }

    retenues.forEach(function (valeur) { params.append(CLE_FILTRE_MOLLET, valeur); });

    return racine() + 'collections/all?' + params.toString();
  }

  /* Redirige vers la collection filtrée. */
  function rediriger(pointure, taille) {
    if (!pointure || !taille) return Promise.resolve(false);
    return chargerFiltres().then(function (filtres) {
      window.location.href = construireUrl(pointure, taille, filtres);
      return true;
    });
  }

  /* Réécrit les value des options d'un <select> de pointure avec les
     libellés de filtre réels, pour que la soumission native du
     formulaire fonctionne aussi. La pointure logique est conservée dans
     l'attribut data-pointure. */
  function appliquerAuSelectPointure(select) {
    if (!select) return Promise.resolve();
    return chargerFiltres().then(function (filtres) {
      for (var i = 0; i < select.options.length; i++) {
        var option = select.options[i];
        var pointure = option.getAttribute('data-pointure') || option.value;
        if (!pointure || !/^\d{2}$/.test(pointure)) continue;
        var libelle = (filtres.pointures && filtres.pointures[pointure]) || POINTURES_REPLI[pointure];
        if (!libelle) continue;
        option.setAttribute('data-pointure', pointure);
        option.value = libelle;
      }
    });
  }

  /* 5. API publique */
  window.GabylouSizes = {
    table: TAILLES_MOLLET,
    varioParTaille: VARIO_PAR_TAILLE,
    tailleMollet: tailleMollet,
    optionsMollet: optionsMollet,
    pointureSelectionnee: pointureSelectionnee
  };

  window.GabylouFilters = {
    charger: chargerFiltres,
    construireUrl: construireUrl,
    rediriger: rediriger,
    appliquerAuSelectPointure: appliquerAuSelectPointure,
    racine: racine
  };

  /* 6. Interface du popup */
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('popup');
    var boutonOuvrir = document.getElementById('popupButton');
    var boutonFermer = document.getElementById('closePopup');
    var affichageTaille = document.getElementById('calculatedSize');
    var affichagePointure = document.getElementById('calculatedFootSize'); // facultatif
    var selectPointure = document.getElementById('search_taille');
    var selectMollet = document.getElementById('search_tailledemollet');
    var boutonAction = document.getElementById('popupAction');

    if (!selectPointure || !selectMollet) return;

    // Préchauffage du cache des filtres, sans bloquer l'affichage.
    chargerFiltres();

    function libelles() {
      var d = (affichageTaille && affichageTaille.dataset) || {};
      return {
        label: d.label || 'Votre taille',
        notFound: d.notFound || 'Taille non trouvée',
        noSelection: d.noSelection || 'Taille non sélectionnée'
      };
    }

    /* Met à jour l'affichage et retourne la taille calculée ('' si aucune). */
    function majAffichage() {
      var l = libelles();
      var pointure = pointureSelectionnee(selectPointure);
      var mollet = selectMollet.value;
      var taille = '';

      if (pointure && mollet) {
        taille = tailleMollet(pointure, mollet);
        if (affichageTaille) {
          affichageTaille.textContent = taille || l.notFound;
        }
      } else if (affichageTaille) {
        affichageTaille.textContent = l.noSelection;
      }

      if (affichagePointure) {
        affichagePointure.textContent = (affichagePointure.dataset.label || '') + ' ' + (pointure || '');
      }

      return taille;
    }

    selectMollet.addEventListener('change', majAffichage);
    selectPointure.addEventListener('change', majAffichage);

    if (boutonOuvrir && popup) {
      boutonOuvrir.addEventListener('click', function () {
        majAffichage();
        popup.style.display = 'flex';
      });
    }

    if (boutonFermer && popup) {
      boutonFermer.addEventListener('click', function () {
        popup.style.display = 'none';
      });
    }

    if (boutonAction) {
      boutonAction.addEventListener('click', function () {
        var taille = majAffichage();
        var pointure = pointureSelectionnee(selectPointure);
        if (!pointure || !taille) return; 
        rediriger(pointure, taille);
      });
    }
  });
})(window, document);
